// extracted by mini-css-extract-plugin
export var carouselWidget = "StrapiReviewsIOComponent-v2-module--carousel-widget--1ae8b";
export var carouselWidget_frame = "StrapiReviewsIOComponent-v2-module--carousel-widget_frame--7c762";
export var root = "StrapiReviewsIOComponent-v2-module--root--d5f4d";
export var title = "StrapiReviewsIOComponent-v2-module--title--cf191";